/* eslint-disable react-hooks/exhaustive-deps */
import { memo, VFC } from "react";
import { Flex, HStack, Spacer, Text } from "@chakra-ui/react";

import appconfig from '../../../config_app.json';

export const Footer: VFC = memo(() => {

  const SYSTEM_VERSION: string = appconfig["SYSTEM_VERSION"];
  const SYSTEM_COPYRIGHT: string = appconfig["SYSTEM_COPYRIGHT"];

  return (
    <>
    <Flex
        as="nav"
        bg="gray.400"
        color="gray.50"
        padding={{ base: 1, md: 2 }}
        w="100%"
        zIndex={-1}
      >
      <HStack w="100%">
        <Text fontSize="sm">
          {SYSTEM_COPYRIGHT}
        </Text>
        <Spacer/>
        <Text fontSize="sm">
          {SYSTEM_VERSION}
        </Text>
      </HStack>
      </Flex>
    </>
  );
});
